import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { corePlatformColors } from '@fc-core/constants/colors';

@Component({
  selector: 'fc-spinner',
  standalone: true,
  template: `
    <span
      [style.width.px]="size()"
      [style.height.px]="size()"
      [style.border-color]="spinnerColor()"
      [style.border-bottom-color]="'transparent'"
      [style.border-width]="borderSize()"
      class="loader"
    ></span>
  `,
  styles: `
    .loader {
      border: 3px solid;
      border-radius: 50%;
      display: inline-block;
      box-sizing: border-box;
      animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.width.px]': 'size()',
    '[style.height.px]': 'size()',
  },
})
export class SpinnerComponent {
  size = input<number>(32);
  color = input<'primary' | 'secondary' | 'error' | 'white' | 'grey'>(
    'primary',
  );
  borderSize = computed(() => this.size() / 8);

  spinnerColor = computed(() => {
    switch (this.color()) {
      case 'primary':
        return corePlatformColors.primary600;
      case 'secondary':
        return corePlatformColors.secondary200;
      case 'error':
        return corePlatformColors.error200;
      case 'white':
        return corePlatformColors.white;
      case 'grey':
        return corePlatformColors.grey600;
    }
  });
}
